import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const HomeTel = (props) => {
  return (
    <FormGroup controlId="homeTel">
      <Col componentClass={ControlLabel} sm={5}>
        Home Tel.
      </Col>
    <Col sm={7}>
      <FormControl type="text" value={props.homeTel} onChange={props.handleChangeHomeTel}
        autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

HomeTel.propTypes = {
  homeTel: PropTypes.string,
  handleChangeHomeTel: PropTypes.func
};

export default HomeTel;



// WEBPACK FOOTER //
// ./src/app/components/homeTel/HomeTel.js